import { Stack } from '@optimus-web/core';
import { CommonFormFields } from '../CommonPlatformProfileForm';
import { EmailsInputField } from './EmailsInputField';

export const NewPlatformProfileForm = () => (
    <Stack vertical spacing="400">
        <Stack vertical spacing="200">
            <EmailsInputField />
            <CommonFormFields />
        </Stack>
    </Stack>
);
